export const calculateTimeDifference = endDate => {
  const parsedDate = `${endDate}T23:59:59`;
  const now = new Date().getTime();
  const endTime = new Date(parsedDate).getTime();
  const timeDiff = endTime - now;
  if (timeDiff <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  const getNumber = (timeInMinSec, divider) => Math.floor(timeDiff % timeInMinSec / divider);
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = getNumber(1000 * 60 * 60 * 24, 1000 * 60 * 60);
  const minutes = getNumber(1000 * 60 * 60, 1000 * 60);
  const seconds = getNumber(1000 * 60, 1000);
  return {
    days,
    hours,
    minutes,
    seconds
  };
};